module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bnzdO"))).then(() => parcelRequire('dJXJK'));